import { render, staticRenderFns } from "./AdunitGroupTable.vue?vue&type=template&id=50301715&scoped=true"
import script from "./AdunitGroupTable.vue?vue&type=script&lang=ts"
export * from "./AdunitGroupTable.vue?vue&type=script&lang=ts"
import style0 from "./AdunitGroupTable.vue?vue&type=style&index=0&id=50301715&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50301715",
  null
  
)

export default component.exports